import { render, staticRenderFns } from "./FavoriteAddresses.vue?vue&type=template&id=7f949391&scoped=true&"
import script from "./FavoriteAddresses.vue?vue&type=script&lang=js&"
export * from "./FavoriteAddresses.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteAddresses.vue?vue&type=style&index=0&id=7f949391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f949391",
  null
  
)

export default component.exports